import type { FC } from 'react';

import { SORT_ENABLED } from '~/constants/community';

import { ReadOnlyBadge } from '../../ui/ReadOnlyBadge';

import { type Space, useSpace } from '../../../_hooks/useSpace';
import { SortOrderDropdown } from './SortOrderDropdown';
import { SpaceMembers } from './SpaceMembers';

const SpaceHeaderContent: FC<{ space: Space }> = ({ space }) => {
  return (
    <div className="hidden md:block sticky top-0 z-10 bg-white px-6 py-4 w-full">
      <div className="relative flex items-center justify-center">
        <h1 className="contents">
          {SORT_ENABLED ? (
            <SortOrderDropdown label={space.name} />
          ) : (
            <span className="text-xl font-semibold leading-6 tracking-[-0.4px] text-black">{space.name}</span>
          )}
        </h1>

        <div className="absolute right-0 flex items-center gap-2">
          <SpaceMembers space={space} />
          {space.read_only && <ReadOnlyBadge />}
        </div>

        {/* Channel join/leave button removed for MVP: channel joining is hidden from the
        UI. The membership hooks (useCanJoinSpace, useSpace's join fields) are retained
        dormant for future use. */}
        {/*
        <div className="absolute right-0 flex items-center gap-2">
          {canJoinChannel && (
            <PillButton
              variant={space.joined ? 'secondary' : 'primary'}
              onClick={space.onToggle}
              disabled={space.isPending}
              className="hidden md:flex"
            >
              {space.joined ? t('community.space.joined') : t('community.space.join')}
            </PillButton>
          )}
        </div> */}
      </div>
    </div>
  );
};

export const SpaceHeader: FC = () => {
  const space = useSpace();
  if (!space) return null;
  return <SpaceHeaderContent space={space} />;
};
